import type { App } from "vue"

type FormatOptions = {
  locale: string
}

export default {
  install: (app: App, options: FormatOptions) => {
    app.provide('dates', {
      format: (value: string) => {
        return new Date(value).toLocaleDateString(options.locale)
      }
    })
  }
}